interface IDownArrowIconProps {
  color?: string;
  className?: string;
  onClick?: () => void;
}

const DownArrowIcon: React.FC<IDownArrowIconProps> = ({
  color,
  className,
  onClick,
}) => (
  <svg
    width="61"
    height="62"
    viewBox="0 0 61 62"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}>
    <g style={{ fill: color || 'var(--tt-dark-purple)' }} fillRule="evenodd">
      <path d="m45.5 20.915 5.02 5.02-20.08 20.08-5.02-5.02z" />
      <path d="m15.38 20.915-5.02 5.02 20.08 20.08 5.02-5.02z" />
    </g>
  </svg>
);

export default DownArrowIcon;
